// language=GraphQL
export const ALL_HIGHLIGHTS_QUERY = `query Query {
  highlights: travelHighlights {
    id
    text
  }
}`

// language=GraphQL
export const SINGLE_HIGHLIGHT_QUERY = `query Query($id: ID!) {
  highlight: travelHighlight(id: $id) {
    id
    text
  }
}`

// language=GraphQL
export const CREATE_HIGHLIGHT_MUTATION = `
  mutation Mutation($input: CreateTravelHighlightInput) {
    highlight: createTravelHighlight(input: $input) {
      id
      text
    }
  }`

// language=GraphQL
export const UPDATE_HIGHLIGHT_MUTATION = `
  mutation Mutation($input: UpdateTravelHighlightInput) {
    highlight: updateTravelHighlight(input: $input) {
      id
      text
    }
  }`

// language=GraphQL
export const DELETE_HIGHLIGHT_MUTATION = `
  mutation Mutation($input: DeleteTravelHighlightInput) {
    deleteTravelHighlight(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_HIGHLIGHT_MUTATION = `
  mutation Mutation($input: DeleteTravelHighlightInput) {
    forceDeleteTravelHighlight(input: $input) {
      success
    }
  }`
// language=GraphQL
export const HIGHLIGHTS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravels: Boolean = false, $withTravelExtensions: Boolean = false) {
  groupedDependents: travelHighlightDependents(id: $id) {
    travels @include(if: $withTravels) {
      id
      name
      isBestseller
      startDate
      endDate
      executionStatus
      title
      description
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      programType
      programText
      minPrice
      minPriceManualOverride
      currency    }
    travelExtensions @include(if: $withTravelExtensions) {
      id
      duration
      name
      description
    }
  }
}`
